import { render, staticRenderFns } from "./ModalBuscarTerritoriosCadastradosPy.vue?vue&type=template&id=b3584df8&lang=pug"
import script from "./ModalBuscarTerritoriosCadastradosPy.vue?vue&type=script&lang=js"
export * from "./ModalBuscarTerritoriosCadastradosPy.vue?vue&type=script&lang=js"
import style0 from "./ModalBuscarTerritoriosCadastradosPy.vue?vue&type=style&index=0&id=b3584df8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports